import { render, staticRenderFns } from "./ComplianceHistory.vue?vue&type=template&id=38bcf291&"
import script from "./ComplianceHistory.vue?vue&type=script&lang=js&"
export * from "./ComplianceHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports